// extracted by mini-css-extract-plugin
module.exports = {"PostMenu__item":"hl_a","PostMenu__item--admin":"hl_b","PostMenu__item--moderator":"hl_c","PostMenu__item--author":"hl_e"};